/** @format */
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SisCommonModule } from 'sis-common';
import { SisComponentsHybridModule } from '../../../sis-components.module.hybrid';
import { StudyRightEducationStructureViewComponent } from './study-right-education-structure-view.component';

/**
 * CUSTOM_ELEMENTS_SCHEMA is used because left-boxes and right-boxes are custom elements
 * used as ng-content selectors by EducationStructurePreviewComponent.
 */
@NgModule({
    declarations: [StudyRightEducationStructureViewComponent],
    imports: [CommonModule, TranslateModule.forChild(), SisCommonModule, SisComponentsHybridModule],
    exports: [StudyRightEducationStructureViewComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StudyRightEducationStructureViewModule {}
